webpackJsonp([1,46,57,58,81,82,83,84,85,86,87,88,89,90,91,92,257],{

/***/ 1198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '40',
                numeric: true
            }, {
                field: 'first_name',
                label: 'First Name'
            }, {
                field: 'last_name',
                label: 'Last Name'
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }]
        };
    }
});

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var data = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }];

        return {
            data: data,
            isEmpty: false,
            isBordered: false,
            isStriped: false,
            isNarrowed: false,
            isHoverable: false,
            isFocusable: false,
            isLoading: false,
            hasMobileCards: true
        };
    }
});

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isBordered),
      callback: function($$v) {
        _vm.isBordered = $$v
      },
      expression: "isBordered"
    }
  }, [_vm._v("Bordered")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isStriped),
      callback: function($$v) {
        _vm.isStriped = $$v
      },
      expression: "isStriped"
    }
  }, [_vm._v("Striped")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isNarrowed),
      callback: function($$v) {
        _vm.isNarrowed = $$v
      },
      expression: "isNarrowed"
    }
  }, [_vm._v("Narrowed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isHoverable),
      callback: function($$v) {
        _vm.isHoverable = $$v
      },
      expression: "isHoverable"
    }
  }, [_vm._v("Hoverable")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isFocusable),
      callback: function($$v) {
        _vm.isFocusable = $$v
      },
      expression: "isFocusable"
    }
  }, [_vm._v("Focusable")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_vm._v("Loading state")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isEmpty),
      callback: function($$v) {
        _vm.isEmpty = $$v
      },
      expression: "isEmpty"
    }
  }, [_vm._v("Empty")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.hasMobileCards),
      callback: function($$v) {
        _vm.hasMobileCards = $$v
      },
      expression: "hasMobileCards"
    }
  }, [_vm._v("Mobile cards "), _c('small', [_vm._v("(collapsed rows)")])])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.isEmpty ? [] : _vm.data,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "hoverable": _vm.isHoverable,
      "loading": _vm.isLoading,
      "focusable": _vm.isFocusable,
      "mobile-cards": _vm.hasMobileCards
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "first_name",
            "label": "First Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "last_name",
            "label": "Last Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "emoticon-sad",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Nothing here.")])])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var data = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }];

        return {
            data: data,
            selected: data[1],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '40',
                numeric: true
            }, {
                field: 'first_name',
                label: 'First Name'
            }, {
                field: 'last_name',
                label: 'Last Name'
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }]
        };
    }
});

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button field is-danger",
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "click": function($event) {
        _vm.selected = null
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Clear selected")])], 1), _vm._v(" "), _c('b-tabs', [_c('b-tab-item', {
    attrs: {
      "label": "Table"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "selected": _vm.selected,
      "focusable": ""
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      }
    }
  })], 1), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Selected"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.selected))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var data = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }];

        return {
            data: data,
            checkboxPosition: 'left',
            checkedRows: [data[1], data[3]],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '40',
                numeric: true
            }, {
                field: 'first_name',
                label: 'First Name'
            }, {
                field: 'last_name',
                label: 'Last Name'
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }]
        };
    }
});

/***/ }),

/***/ 1205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('button', {
    staticClass: "button field is-danger",
    attrs: {
      "disabled": !_vm.checkedRows.length
    },
    on: {
      "click": function($event) {
        _vm.checkedRows = []
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Clear checked")])], 1), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.checkboxPosition),
      callback: function($$v) {
        _vm.checkboxPosition = $$v
      },
      expression: "checkboxPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v("Checkbox at left")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v("Checkbox at right")])])], 1), _vm._v(" "), _c('b-tabs', [_c('b-tab-item', {
    attrs: {
      "label": "Table"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "checked-rows": _vm.checkedRows,
      "is-row-checkable": function (row) { return row.id !== 3; },
      "checkable": "",
      "checkbox-position": _vm.checkboxPosition
    },
    on: {
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [_c('template', {
    slot: "bottom-left"
  }, [_c('b', [_vm._v("Total checked")]), _vm._v(": " + _vm._s(_vm.checkedRows.length) + "\n                    ")])], 2)], 1), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Checked rows"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.checkedRows))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '100',
                numeric: true,
                searchable: true
            }, {
                field: 'first_name',
                label: 'First Name',
                searchable: true
            }, {
                field: 'last_name',
                label: 'Last Name',
                searchable: true
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }]
        };
    }
});

/***/ }),

/***/ 1207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = __webpack_require__(902);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: _data,
            isPaginated: true,
            isPaginationSimple: false,
            paginationPosition: 'bottom',
            defaultSortDirection: 'asc',
            sortIcon: 'arrow-up',
            sortIconSize: 'is-small',
            currentPage: 1,
            perPage: 5
        };
    }
});

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.defaultSortDirection),
      callback: function($$v) {
        _vm.defaultSortDirection = $$v
      },
      expression: "defaultSortDirection"
    }
  }, [_c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Default sort direction: ASC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Default sort direction: DESC")])]), _vm._v(" "), _c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isPaginated
    },
    on: {
      "click": function($event) {
        _vm.currentPage = 2
      }
    }
  }, [_vm._v("Set page to 2")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isPaginated),
      callback: function($$v) {
        _vm.isPaginated = $$v
      },
      expression: "isPaginated"
    }
  }, [_vm._v("Paginated")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.isPaginationSimple),
      callback: function($$v) {
        _vm.isPaginationSimple = $$v
      },
      expression: "isPaginationSimple"
    }
  }, [_vm._v("Simple pagination")])], 1), _vm._v(" "), _c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.paginationPosition),
      callback: function($$v) {
        _vm.paginationPosition = $$v
      },
      expression: "paginationPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "bottom"
    }
  }, [_vm._v("bottom pagination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top"
    }
  }, [_vm._v("top pagination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("both")])]), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.sortIcon),
      callback: function($$v) {
        _vm.sortIcon = $$v
      },
      expression: "sortIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "arrow-up"
    }
  }, [_vm._v("Arrow sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-up"
    }
  }, [_vm._v("Caret sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "chevron-up"
    }
  }, [_vm._v("Chevron sort icon ")])]), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.sortIconSize),
      callback: function($$v) {
        _vm.sortIconSize = $$v
      },
      expression: "sortIconSize"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("Small sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Regular sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("Medium sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("Large sort icon")])])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.data,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "pagination-simple": _vm.isPaginationSimple,
      "pagination-position": _vm.paginationPosition,
      "default-sort-direction": _vm.defaultSortDirection,
      "sort-icon": _vm.sortIcon,
      "sort-icon-size": _vm.sortIconSize,
      "default-sort": "user.first_name",
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "sortable": "",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = __webpack_require__(902);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: _data,
            defaultOpenedDetails: [1],
            showDetailIcon: true
        };
    },

    methods: {
        toggle: function toggle(row) {
            this.$refs.table.toggleDetails(row);
        }
    }
});

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.showDetailIcon),
      callback: function($$v) {
        _vm.showDetailIcon = $$v
      },
      expression: "showDetailIcon"
    }
  }, [_vm._v("Show detail icon")])], 1)]), _vm._v(" "), _c('b-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "paginated": "",
      "per-page": "5",
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id",
      "show-detail-icon": _vm.showDetailIcon,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "details-open": function (row, index) { return _vm.$buefy.toast.open(("Expanded " + (row.user.first_name))); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name",
            "sortable": ""
          }
        }, [(_vm.showDetailIcon) ? [_vm._v("\n                        " + _vm._s(props.row.user.first_name) + "\n                    ")] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.toggle(props.row)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(props.row.user.first_name) + "\n                        ")])]], 2), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-64x64"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/placeholder-128x128.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(props.row.user.first_name) + " " + _vm._s(props.row.user.last_name))]), _vm._v(" "), _c('small', [_vm._v("@" + _vm._s(props.row.user.first_name))]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                                Proin ornare magna eros, eu pellentesque tortor vestibulum ut.\n                                Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.\n                            ")])])])])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{
                name: 'Board Games',
                sold: 131,
                available: 301,
                items: [{
                    name: 'Monopoly',
                    sold: 57,
                    available: 100
                }, {
                    name: 'Scrabble',
                    sold: 23,
                    available: 84
                }, {
                    name: 'Chess',
                    sold: 37,
                    available: 61
                }, {
                    name: 'Battleships',
                    sold: 14,
                    available: 56
                }]
            }, {
                name: 'Jigsaws & Puzzles',
                sold: 88,
                available: 167,
                items: [{
                    name: 'World Map',
                    sold: 31,
                    available: 38
                }, {
                    name: 'London',
                    sold: 23,
                    available: 29
                }, {
                    name: 'Sharks',
                    sold: 20,
                    available: 44
                }, {
                    name: 'Disney',
                    sold: 14,
                    available: 56
                }]
            }, {
                name: 'Books',
                sold: 434,
                available: 721,
                items: [{
                    name: 'Hamlet',
                    sold: 101,
                    available: 187
                }, {
                    name: 'The Lord Of The Rings',
                    sold: 85,
                    available: 156
                }, {
                    name: 'To Kill a Mockingbird',
                    sold: 78,
                    available: 131
                }, {
                    name: 'Catch-22',
                    sold: 73,
                    available: 98
                }, {
                    name: 'Frankenstein',
                    sold: 51,
                    available: 81
                }, {
                    name: 'Alice\'s Adventures In Wonderland',
                    sold: 46,
                    available: 68
                }]
            }],
            columnsVisible: {
                name: { title: 'Name', display: true },
                sold: { title: 'Stock Sold', display: true },
                available: { title: 'Stock Available', display: true },
                cleared: { title: 'Stock Cleared', display: true }
            },
            showDetailIcon: true
        };
    },

    methods: {
        toggle: function toggle(row) {
            this.$refs.table.toggleDetails(row);
        }
    }
});

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.showDetailIcon),
      callback: function($$v) {
        _vm.showDetailIcon = $$v
      },
      expression: "showDetailIcon"
    }
  }, [_vm._v("Detail column")])], 1), _vm._v(" "), _vm._l((_vm.columnsVisible), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "control"
    }, [_c('b-checkbox', {
      model: {
        value: (column.display),
        callback: function($$v) {
          _vm.$set(column, "display", $$v)
        },
        expression: "column.display"
      }
    }, [_vm._v("\n                    " + _vm._s(column.title) + "\n                ")])], 1)
  })], 2), _vm._v(" "), _c('b-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "detailed": "",
      "hoverable": "",
      "custom-detail-row": "",
      "opened-detailed": ['Board Games'],
      "default-sort": ['name', 'asc'],
      "detail-key": "name",
      "show-detail-icon": _vm.showDetailIcon
    },
    on: {
      "details-open": function (row, index) { return _vm.$buefy.toast.open(("Expanded " + (row.name))); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "visible": _vm.columnsVisible['name'].display,
            "label": _vm.columnsVisible['name'].title,
            "width": "300",
            "sortable": ""
          }
        }, [(_vm.showDetailIcon) ? [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.toggle(props.row)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(props.row.name) + "\n                        ")])]], 2), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "sold",
            "visible": _vm.columnsVisible['sold'].display,
            "label": _vm.columnsVisible['sold'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.sold) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "available",
            "visible": _vm.columnsVisible['available'].display,
            "label": _vm.columnsVisible['available'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.available) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "visible": _vm.columnsVisible['cleared'].display,
            "label": _vm.columnsVisible['cleared'].title,
            "centered": ""
          }
        }, [_c('span', {
          class: [
            'tag',
            {
              'is-danger': props.row.sold / props.row.available <= 0.45
            },
            {
              'is-success': props.row.sold / props.row.available > 0.45
            }
          ]
        }, [_vm._v("\n                        " + _vm._s(Math.round((props.row.sold / props.row.available) * 100)) + "%\n                    ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return _vm._l((props.row.items), function(item) {
          return _c('tr', {
            key: item.name
          }, [(_vm.showDetailIcon) ? _c('td') : _vm._e(), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['name'].display),
              expression: "columnsVisible['name'].display"
            }]
          }, [_vm._v("    " + _vm._s(item.name))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['sold'].display),
              expression: "columnsVisible['sold'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.sold))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['available'].display),
              expression: "columnsVisible['available'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.available))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['cleared'].display),
              expression: "columnsVisible['cleared'].display"
            }],
            staticClass: "has-text-centered"
          }, [_c('span', {
            class: [
              'tag',
              {
                'is-danger': item.sold / item.available <= 0.45
              },
              {
                'is-success': item.sold / item.available > 0.45
              }
            ]
          }, [_vm._v("\n                            " + _vm._s(Math.round((item.sold / item.available) * 100)) + "%\n                        ")])])])
        })
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1215);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(900)("763cdfc8", content, true);

/***/ }),

/***/ 1215:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(899)(true);
// imports


// module
exports.push([module.i, "\ntr.is-info {\n        background: #167df0;\n        color: #fff;\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/table/examples/ExRowStatus.vue"],"names":[],"mappings":";AACA;QACQ,oBAAoB;QACpB,YAAY;CACnB","file":"ExRowStatus.vue","sourcesContent":["\ntr.is-info {\n        background: #167df0;\n        color: #fff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '40',
                numeric: true
            }, {
                field: 'first_name',
                label: 'First Name'
            }, {
                field: 'last_name',
                label: 'Last Name'
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }]
        };
    }
});

/***/ }),

/***/ 1217:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "row-class": function (row, index) { return row.id === 1 && 'is-info'; }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }]
        };
    }
});

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.data
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v(" \n                " + _vm._s(props.row.id) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name"
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v("\n                " + _vm._s(props.row.first_name) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name"
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v("\n                " + _vm._s(props.row.last_name) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                    " + _vm._s(props.row.gender) + "\n                ")], 1)])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'contributor': 'Jesse Simmons', 'posts': 2, 'comments': 5 }, { 'id': 2, 'contributor': 'John Jacobs', 'posts': 11, 'comments': 42 }, { 'id': 3, 'contributor': 'Tina Gilbert', 'posts': 0, 'comments': 7 }, { 'id': 4, 'contributor': 'Clarence Flores', 'posts': 4, 'comments': 4 }, { 'id': 5, 'contributor': 'Anne Lee', 'posts': 1, 'comments': 2 }],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '100',
                numeric: true,
                subheading: 'Total:'
            }, {
                field: 'contributor',
                label: 'Contributor'
            }, {
                field: 'posts',
                label: 'Posts',
                subheading: 18
            }, {
                field: 'comments',
                label: 'Comments',
                subheading: 60
            }]
        };
    }
});

/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var tableDataSimple = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }];

        return {
            tableDataSimple: tableDataSimple,
            columnsTemplate: [{ title: 'ID', field: 'id', visible: true }, { title: 'First Name', field: 'first_name', visible: true }, { title: 'Last Name', field: 'last_name', visible: true }, { title: 'Date', field: 'date', visible: true }, { title: 'Gender', field: 'gender', visible: true }]
        };
    }
});

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, _vm._l((_vm.columnsTemplate), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "control"
    }, [_c('b-checkbox', {
      model: {
        value: (column.visible),
        callback: function($$v) {
          _vm.$set(column, "visible", $$v)
        },
        expression: "column.visible"
      }
    }, [_vm._v("\n                    " + _vm._s(column.title) + "\n                ")])], 1)
  })), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((_vm.columnsTemplate), function(column, index) {
          return _c('b-table-column', {
            key: index,
            attrs: {
              "label": column.title,
              "visible": column.visible
            }
          }, [_vm._v("\n                    " + _vm._s(props.row[column.field]) + "\n                ")])
        })
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var tableDataSimple = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }];

        return {
            tableDataSimple: tableDataSimple,
            isCustom: false
        };
    }
});

/***/ }),

/***/ 1225:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isCustom),
      callback: function($$v) {
        _vm.isCustom = $$v
      },
      expression: "isCustom"
    }
  }, [_vm._v("Custom")])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "First Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Last Name"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Date",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.gender) + "\n                ")])]
      }
    }])
  }, [(!_vm.isCustom) ? _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "has-text-right"
  }, [_vm._v("\n                    Footer\n                ")])]) : _c('template', {
    slot: "footer"
  }, [_c('th', {
    staticClass: "is-hidden-mobile",
    staticStyle: {
      "width": "40px"
    }
  }, [_c('div', {
    staticClass: "th-wrap is-numeric"
  }, [_vm._v(" ID ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" First Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Last Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap is-centered"
  }, [_vm._v(" Date ")])]), _vm._v(" "), _c('th', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', {
    staticClass: "th-wrap"
  }, [_vm._v(" Gender ")])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [],
            total: 0,
            loading: false,
            sortField: 'vote_count',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20
        };
    },

    methods: {
        /*
        * Load async data
        */
        loadAsyncData: function loadAsyncData() {
            var _this = this;

            var params = ['api_key=bb6f51bef07465653c3e553d6ab161a8', 'language=en-US', 'include_adult=false', 'include_video=false', 'sort_by=' + this.sortField + '.' + this.sortOrder, 'page=' + this.page].join('&');

            this.loading = true;
            this.$http.get('https://api.themoviedb.org/3/discover/movie?' + params).then(function (_ref) {
                var data = _ref.data;

                // api.themoviedb.org manage max 1000 pages
                _this.data = [];
                var currentTotal = data.total_results;
                if (data.total_results / _this.perPage > 1000) {
                    currentTotal = _this.perPage * 1000;
                }
                _this.total = currentTotal;
                data.results.forEach(function (item) {
                    item.release_date = item.release_date.replace(/-/g, '/');
                    _this.data.push(item);
                });
                _this.loading = false;
            }).catch(function (error) {
                _this.data = [];
                _this.total = 0;
                _this.loading = false;
                throw error;
            });
        },

        /*
        * Handle page-change event
        */
        onPageChange: function onPageChange(page) {
            this.page = page;
            this.loadAsyncData();
        },

        /*
        * Handle sort event
        */
        onSort: function onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.loadAsyncData();
        },

        /*
        * Type style in relation to the value
        */
        type: function type(value) {
            var number = parseFloat(value);
            if (number < 6) {
                return 'is-danger';
            } else if (number >= 6 && number < 8) {
                return 'is-warning';
            } else if (number >= 8) {
                return 'is-success';
            }
        }
    },
    filters: {
        /**
        * Filter to truncate string, accepts a length parameter
        */
        truncate: function truncate(value, length) {
            return value.length > length ? value.substr(0, length) + '...' : value;
        }
    },
    mounted: function mounted() {
        this.loadAsyncData();
    }
});

/***/ }),

/***/ 1227:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "loading": _vm.loading,
      "paginated": "",
      "backend-pagination": "",
      "total": _vm.total,
      "per-page": _vm.perPage,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page",
      "backend-sorting": "",
      "default-sort-direction": _vm.defaultSortOrder,
      "default-sort": [_vm.sortField, _vm.sortOrder]
    },
    on: {
      "page-change": _vm.onPageChange,
      "sort": _vm.onSort
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "original_title",
            "label": "Title",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.original_title) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_average",
            "label": "Vote Average",
            "numeric": "",
            "sortable": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          class: _vm.type(props.row.vote_average)
        }, [_vm._v("\n                        " + _vm._s(props.row.vote_average) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "vote_count",
            "label": "Vote Count",
            "numeric": "",
            "sortable": ""
          }
        }, [_vm._v("\n                     " + _vm._s(props.row.vote_count) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "release_date",
            "label": "Release Date",
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.release_date ? new Date(props.row.release_date).toLocaleDateString() : '') + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Overview",
            "width": "500"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("truncate")(props.row.overview, 80)) + "\n                ")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }],
            columns: [{
                field: 'id',
                label: 'ID',
                width: '40',
                numeric: true
            }, {
                field: 'first_name',
                label: 'First Name'
            }, {
                field: 'last_name',
                label: 'Last Name'
            }, {
                field: 'date',
                label: 'Date',
                centered: true
            }, {
                field: 'gender',
                label: 'Gender'
            }],
            draggingRow: null,
            draggingRowIndex: null
        };
    },

    methods: {
        dragstart: function dragstart(payload) {
            this.draggingRow = payload.row;
            this.draggingRowIndex = payload.index;
            payload.event.dataTransfer.effectAllowed = 'copy';
        },
        dragover: function dragover(payload) {
            payload.event.dataTransfer.dropEffect = 'copy';
            payload.event.target.closest('tr').classList.add('is-selected');
            payload.event.preventDefault();
        },
        dragleave: function dragleave(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected');
            payload.event.preventDefault();
        },
        drop: function drop(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected');
            var droppedOnRowIndex = payload.index;
            this.$buefy.toast.open('Moved ' + this.draggingRow.first_name + ' from row ' + (this.draggingRowIndex + 1) + ' to ' + (droppedOnRowIndex + 1));
        }
    }
});

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "draggable": ""
    },
    on: {
      "dragstart": _vm.dragstart,
      "drop": _vm.drop,
      "dragover": _vm.dragover,
      "dragleave": _vm.dragleave
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_table__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExSandbox__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExSandbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExSandbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSandbox__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSandbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSandbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExSelection__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExSelection__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExCheckable__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExCheckable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExCheckable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExCheckable__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExCheckable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExCheckable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExSearchable__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExSearchable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__examples_ExSearchable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExSearchable__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExSearchable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExSearchable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExPaginationSort__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExPaginationSort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__examples_ExPaginationSort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExPaginationSort__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExPaginationSort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExPaginationSort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__examples_ExDetailedRow__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__examples_ExDetailedRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__examples_ExDetailedRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExDetailedRow__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExDetailedRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExDetailedRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__examples_ExCustomDetailedRow__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__examples_ExCustomDetailedRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__examples_ExCustomDetailedRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExCustomDetailedRow__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExCustomDetailedRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExCustomDetailedRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__examples_ExRowStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__examples_ExRowStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__examples_ExRowStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExRowStatus__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExRowStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExRowStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__examples_ExCustomHeaders__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__examples_ExCustomHeaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__examples_ExCustomHeaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExCustomHeaders__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExCustomHeaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExCustomHeaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__examples_ExSubheadings__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__examples_ExSubheadings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__examples_ExSubheadings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__raw_loader_examples_ExSubheadings__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__raw_loader_examples_ExSubheadings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__raw_loader_examples_ExSubheadings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__examples_ExToggleColumns__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__examples_ExToggleColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__examples_ExToggleColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__raw_loader_examples_ExToggleColumns__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__raw_loader_examples_ExToggleColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__raw_loader_examples_ExToggleColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__examples_ExFooter__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__examples_ExFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__examples_ExFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__raw_loader_examples_ExFooter__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__raw_loader_examples_ExFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__raw_loader_examples_ExFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__examples_ExAsyncData__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__examples_ExAsyncData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__examples_ExAsyncData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__raw_loader_examples_ExAsyncData__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__raw_loader_examples_ExAsyncData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__raw_loader_examples_ExAsyncData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__examples_ExDraggableRows__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__examples_ExDraggableRows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__examples_ExDraggableRows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__raw_loader_examples_ExDraggableRows__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__raw_loader_examples_ExDraggableRows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__raw_loader_examples_ExDraggableRows__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















































/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_table__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSandbox: __WEBPACK_IMPORTED_MODULE_3__examples_ExSandbox___default.a,
            ExSelection: __WEBPACK_IMPORTED_MODULE_5__examples_ExSelection___default.a,
            ExCheckable: __WEBPACK_IMPORTED_MODULE_7__examples_ExCheckable___default.a,
            ExSearchable: __WEBPACK_IMPORTED_MODULE_9__examples_ExSearchable___default.a,
            ExPaginationSort: __WEBPACK_IMPORTED_MODULE_11__examples_ExPaginationSort___default.a,
            ExDetailedRow: __WEBPACK_IMPORTED_MODULE_13__examples_ExDetailedRow___default.a,
            ExCustomDetailedRow: __WEBPACK_IMPORTED_MODULE_15__examples_ExCustomDetailedRow___default.a,
            ExRowStatus: __WEBPACK_IMPORTED_MODULE_17__examples_ExRowStatus___default.a,
            ExCustomHeaders: __WEBPACK_IMPORTED_MODULE_19__examples_ExCustomHeaders___default.a,
            ExSubheadings: __WEBPACK_IMPORTED_MODULE_21__examples_ExSubheadings___default.a,
            ExToggleColumns: __WEBPACK_IMPORTED_MODULE_23__examples_ExToggleColumns___default.a,
            ExFooter: __WEBPACK_IMPORTED_MODULE_25__examples_ExFooter___default.a,
            ExAsyncData: __WEBPACK_IMPORTED_MODULE_27__examples_ExAsyncData___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExDraggableRows: __WEBPACK_IMPORTED_MODULE_29__examples_ExDraggableRows___default.a,
            ExSandboxCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExSandbox___default.a,
            ExSelectionCode: __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExSelection___default.a,
            ExCheckableCode: __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExCheckable___default.a,
            ExSearchableCode: __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExSearchable___default.a,
            ExPaginationSortCode: __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExPaginationSort___default.a,
            ExDetailedRowCode: __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExDetailedRow___default.a,
            ExCustomDetailedRowCode: __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExCustomDetailedRow___default.a,
            ExRowStatusCode: __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExRowStatus___default.a,
            ExCustomHeadersCode: __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExCustomHeaders___default.a,
            ExSubheadingsCode: __WEBPACK_IMPORTED_MODULE_22__raw_loader_examples_ExSubheadings___default.a,
            ExToggleColumnsCode: __WEBPACK_IMPORTED_MODULE_24__raw_loader_examples_ExToggleColumns___default.a,
            ExFooterCode: __WEBPACK_IMPORTED_MODULE_26__raw_loader_examples_ExFooter___default.a,
            ExAsyncDataCode: __WEBPACK_IMPORTED_MODULE_28__raw_loader_examples_ExAsyncData___default.a,
            ExDraggableRowsCode: __WEBPACK_IMPORTED_MODULE_30__raw_loader_examples_ExDraggableRows___default.a
        };
    }
});

/***/ }),

/***/ 1512:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-table :data=\"data\" :columns=\"columns\"></b-table>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                    { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                    { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                    { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                    { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n                ],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '40',\n                        numeric: true\n                    },\n                    {\n                        field: 'first_name',\n                        label: 'First Name',\n                    },\n                    {\n                        field: 'last_name',\n                        label: 'Last Name',\n                    },\n                    {\n                        field: 'date',\n                        label: 'Date',\n                        centered: true\n                    },\n                    {\n                        field: 'gender',\n                        label: 'Gender',\n                    }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1513:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <div class=\"control\">\n                <b-switch v-model=\"isBordered\">Bordered</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isStriped\">Striped</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isNarrowed\">Narrowed</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isHoverable\">Hoverable</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isFocusable\">Focusable</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isLoading\">Loading state</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"isEmpty\">Empty</b-switch>\n            </div>\n            <div class=\"control\">\n                <b-switch v-model=\"hasMobileCards\">Mobile cards <small>(collapsed rows)</small></b-switch>\n            </div>\n        </b-field>\n\n        <b-table\n            :data=\"isEmpty ? [] : data\"\n            :bordered=\"isBordered\"\n            :striped=\"isStriped\"\n            :narrowed=\"isNarrowed\"\n            :hoverable=\"isHoverable\"\n            :loading=\"isLoading\"\n            :focusable=\"isFocusable\"\n            :mobile-cards=\"hasMobileCards\">\n\n            <template slot-scope=\"props\">\n                <b-table-column field=\"id\" label=\"ID\" width=\"40\" numeric>\n                    {{ props.row.id }}\n                </b-table-column>\n\n                <b-table-column field=\"first_name\" label=\"First Name\">\n                    {{ props.row.first_name }}\n                </b-table-column>\n\n                <b-table-column field=\"last_name\" label=\"Last Name\">\n                    {{ props.row.last_name }}\n                </b-table-column>\n\n                <b-table-column field=\"date\" label=\"Date\" centered>\n                    <span class=\"tag is-success\">\n                        {{ new Date(props.row.date).toLocaleDateString() }}\n                    </span>\n                </b-table-column>\n\n                <b-table-column label=\"Gender\">\n                    <span>\n                        <b-icon pack=\"fas\"\n                            :icon=\"props.row.gender === 'Male' ? 'mars' : 'venus'\">\n                        </b-icon>\n                        {{ props.row.gender }}\n                    </span>\n                </b-table-column>\n            </template>\n\n            <template slot=\"empty\">\n                <section class=\"section\">\n                    <div class=\"content has-text-grey has-text-centered\">\n                        <p>\n                            <b-icon\n                                icon=\"emoticon-sad\"\n                                size=\"is-large\">\n                            </b-icon>\n                        </p>\n                        <p>Nothing here.</p>\n                    </div>\n                </section>\n            </template>\n        </b-table>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            const data = [\n                { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' },\n                { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' },\n                { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' },\n                { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' },\n                { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }\n            ]\n\n            return {\n                data,\n                isEmpty: false,\n                isBordered: false,\n                isStriped: false,\n                isNarrowed: false,\n                isHoverable: false,\n                isFocusable: false,\n                isLoading: false,\n                hasMobileCards: true\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1514:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <button class=\"button field is-danger\" @click=\"selected = null\"\n            :disabled=\"!selected\">\n            <b-icon icon=\"close\"></b-icon>\n            <span>Clear selected</span>\n        </button>\n\n        <b-tabs>\n            <b-tab-item label=\"Table\">\n                <b-table\n                    :data=\"data\"\n                    :columns=\"columns\"\n                    :selected.sync=\"selected\"\n                    focusable>\n                </b-table>\n            </b-tab-item>\n\n            <b-tab-item label=\"Selected\">\n                <pre>{{ selected }}</pre>\n            </b-tab-item>\n        </b-tabs>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            const data = [\n                { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n            ]\n\n            return {\n                data,\n                selected: data[1],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '40',\n                        numeric: true\n                    },\n                    {\n                        field: 'first_name',\n                        label: 'First Name',\n                    },\n                    {\n                        field: 'last_name',\n                        label: 'Last Name',\n                    },\n                    {\n                        field: 'date',\n                        label: 'Date',\n                        centered: true\n                    },\n                    {\n                        field: 'gender',\n                        label: 'Gender',\n                    }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1515:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <button class=\"button field is-danger\" @click=\"checkedRows = []\"\n                :disabled=\"!checkedRows.length\">\n                <b-icon icon=\"close\"></b-icon>\n                <span>Clear checked</span>\n            </button>\n            <b-select v-model=\"checkboxPosition\">\n                <option value=\"left\">Checkbox at left</option>\n                <option value=\"right\">Checkbox at right</option>\n            </b-select>\n        </b-field>\n\n        <b-tabs>\n            <b-tab-item label=\"Table\">\n                <b-table\n                    :data=\"data\"\n                    :columns=\"columns\"\n                    :checked-rows.sync=\"checkedRows\"\n                    :is-row-checkable=\"(row) => row.id !== 3\"\n                    checkable\n                    :checkbox-position=\"checkboxPosition\">\n\n                    <template slot=\"bottom-left\">\n                        <b>Total checked</b>: {{ checkedRows.length }}\n                    </template>\n                </b-table>\n            </b-tab-item>\n\n            <b-tab-item label=\"Checked rows\">\n                <pre>{{ checkedRows }}</pre>\n            </b-tab-item>\n        </b-tabs>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            const data = [\n                { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n            ]\n\n            return {\n                data,\n                checkboxPosition: 'left',\n                checkedRows: [data[1], data[3]],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '40',\n                        numeric: true\n                    },\n                    {\n                        field: 'first_name',\n                        label: 'First Name',\n                    },\n                    {\n                        field: 'last_name',\n                        label: 'Last Name',\n                    },\n                    {\n                        field: 'date',\n                        label: 'Date',\n                        centered: true\n                    },\n                    {\n                        field: 'gender',\n                        label: 'Gender',\n                    }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1516:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-table\n            :data=\"data\"\n            :columns=\"columns\">\n        </b-table>\n    </section>\n</template>\n\n <script>\n    export default {\n        data() {\n            return {\n                data: [\n                    { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                    { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                    { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                    { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                    { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n                ],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '100',\n                        numeric: true,\n                        searchable: true,\n                    },\n                    {\n                        field: 'first_name',\n                        label: 'First Name',\n                        searchable: true,\n                    },\n                    {\n                        field: 'last_name',\n                        label: 'Last Name',\n                        searchable: true,\n                    },\n                    {\n                        field: 'date',\n                        label: 'Date',\n                        centered: true\n                    },\n                    {\n                        field: 'gender',\n                        label: 'Gender',\n                    }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1517:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <b-select v-model=\"defaultSortDirection\">\n                <option value=\"asc\">Default sort direction: ASC</option>\n                <option value=\"desc\">Default sort direction: DESC</option>\n            </b-select>\n            <b-select v-model=\"perPage\" :disabled=\"!isPaginated\">\n                <option value=\"5\">5 per page</option>\n                <option value=\"10\">10 per page</option>\n                <option value=\"15\">15 per page</option>\n                <option value=\"20\">20 per page</option>\n            </b-select>\n            <div class=\"control\">\n                <button class=\"button\" @click=\"currentPage = 2\" :disabled=\"!isPaginated\">Set page to 2</button>\n            </div>\n            <div class=\"control is-flex\">\n                <b-switch v-model=\"isPaginated\">Paginated</b-switch>\n            </div>\n            <div class=\"control is-flex\">\n                <b-switch v-model=\"isPaginationSimple\" :disabled=\"!isPaginated\">Simple pagination</b-switch>\n            </div>\n            <b-select v-model=\"paginationPosition\" :disabled=\"!isPaginated\">\n                <option value=\"bottom\">bottom pagination</option>\n                <option value=\"top\">top pagination</option>\n                <option value=\"both\">both</option>\n            </b-select>\n            <b-select v-model=\"sortIcon\">\n                <option value=\"arrow-up\">Arrow sort icon</option>\n                <option value=\"menu-up\">Caret sort icon</option>\n                <option value=\"chevron-up\">Chevron sort icon </option>\n            </b-select>\n            <b-select v-model=\"sortIconSize\">\n                <option value=\"is-small\">Small sort icon</option>\n                <option value=\"\">Regular sort icon</option>\n                <option value=\"is-medium\">Medium sort icon</option>\n                <option value=\"is-large\">Large sort icon</option>\n            </b-select>\n        </b-field>\n\n        <b-table\n            :data=\"data\"\n            :paginated=\"isPaginated\"\n            :per-page=\"perPage\"\n            :current-page.sync=\"currentPage\"\n            :pagination-simple=\"isPaginationSimple\"\n            :pagination-position=\"paginationPosition\"\n            :default-sort-direction=\"defaultSortDirection\"\n            :sort-icon=\"sortIcon\"\n            :sort-icon-size=\"sortIconSize\"\n            default-sort=\"user.first_name\"\n            aria-next-label=\"Next page\"\n            aria-previous-label=\"Previous page\"\n            aria-page-label=\"Page\"\n            aria-current-label=\"Current page\">\n\n            <template slot-scope=\"props\">\n                <b-table-column field=\"id\" label=\"ID\" width=\"40\" sortable numeric>\n                    {{ props.row.id }}\n                </b-table-column>\n\n                <b-table-column field=\"user.first_name\" label=\"First Name\" sortable>\n                    {{ props.row.user.first_name }}\n                </b-table-column>\n\n                <b-table-column field=\"user.last_name\" label=\"Last Name\" sortable>\n                    {{ props.row.user.last_name }}\n                </b-table-column>\n\n                <b-table-column field=\"date\" label=\"Date\" sortable centered>\n                    <span class=\"tag is-success\">\n                        {{ new Date(props.row.date).toLocaleDateString() }}\n                    </span>\n                </b-table-column>\n\n                <b-table-column label=\"Gender\">\n                    <span>\n                        <b-icon pack=\"fas\"\n                            :icon=\"props.row.gender === 'Male' ? 'mars' : 'venus'\">\n                        </b-icon>\n                        {{ props.row.gender }}\n                    </span>\n                </b-table-column>\n            </template>\n        </b-table>\n    </section>\n</template>\n\n<script>\n    const data = require('@/data/sample.json')\n\n    export default {\n        data() {\n            return {\n                data,\n                isPaginated: true,\n                isPaginationSimple: false,\n                paginationPosition: 'bottom',\n                defaultSortDirection: 'asc',\n                sortIcon: 'arrow-up',\n                sortIconSize: 'is-small',\n                currentPage: 1,\n                perPage: 5\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1518:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <b-field grouped group-multiline>\n            <div class=\"control\">\n                <b-switch v-model=\"showDetailIcon\">Show detail icon</b-switch>\n            </div>\n        </b-field>\n\n        <b-table\n            :data=\"data\"\n            ref=\"table\"\n            paginated\n            per-page=\"5\"\n            :opened-detailed=\"defaultOpenedDetails\"\n            detailed\n            detail-key=\"id\"\n            @details-open=\"(row, index) => $buefy.toast.open(`Expanded ${row.user.first_name}`)\"\n            :show-detail-icon=\"showDetailIcon\"\n            aria-next-label=\"Next page\"\n            aria-previous-label=\"Previous page\"\n            aria-page-label=\"Page\"\n            aria-current-label=\"Current page\">\n\n            <template slot-scope=\"props\">\n                <b-table-column field=\"id\" label=\"ID\" width=\"40\" numeric>\n                    {{ props.row.id }}\n                </b-table-column>\n\n                <b-table-column field=\"user.first_name\" label=\"First Name\" sortable>\n                    <template v-if=\"showDetailIcon\">\n                        {{ props.row.user.first_name }}\n                    </template>\n                    <template v-else>\n                        <a @click=\"toggle(props.row)\">\n                            {{ props.row.user.first_name }}\n                        </a>\n                    </template>\n                </b-table-column>\n\n                <b-table-column field=\"user.last_name\" label=\"Last Name\" sortable>\n                    {{ props.row.user.last_name }}\n                </b-table-column>\n\n                <b-table-column field=\"date\" label=\"Date\" sortable centered>\n                    <span class=\"tag is-success\">\n                        {{ new Date(props.row.date).toLocaleDateString() }}\n                    </span>\n                </b-table-column>\n\n                <b-table-column label=\"Gender\">\n                    <span>\n                        <b-icon pack=\"fas\"\n                            :icon=\"props.row.gender === 'Male' ? 'mars' : 'venus'\">\n                        </b-icon>\n                        {{ props.row.gender }}\n                    </span>\n                </b-table-column>\n            </template>\n\n            <template slot=\"detail\" slot-scope=\"props\">\n                <article class=\"media\">\n                    <figure class=\"media-left\">\n                        <p class=\"image is-64x64\">\n                            <img src=\"/static/img/placeholder-128x128.png\">\n                        </p>\n                    </figure>\n                    <div class=\"media-content\">\n                        <div class=\"content\">\n                            <p>\n                                <strong>{{ props.row.user.first_name }} {{ props.row.user.last_name }}</strong>\n                                <small>@{{ props.row.user.first_name }}</small>\n                                <small>31m</small>\n                                <br>\n                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                                Proin ornare magna eros, eu pellentesque tortor vestibulum ut.\n                                Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.\n                            </p>\n                        </div>\n                    </div>\n                </article>\n            </template>\n        </b-table>\n\n    </section>\n</template>\n\n<script>\n    const data = require('@/data/sample.json')\n\n    export default {\n        data() {\n            return {\n                data,\n                defaultOpenedDetails: [1],\n                showDetailIcon: true\n            }\n        },\n        methods: {\n            toggle(row) {\n                this.$refs.table.toggleDetails(row)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1519:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <div class=\"control\">\n                <b-checkbox v-model=\"showDetailIcon\">Detail column</b-checkbox>\n            </div>\n            <div v-for=\"(column, index) in columnsVisible\"\n                 :key=\"index\"\n                 class=\"control\">\n                <b-checkbox v-model=\"column.display\">\n                    {{ column.title }}\n                </b-checkbox>\n            </div>\n        </b-field>\n\n        <b-table\n            :data=\"data\"\n            ref=\"table\"\n            detailed\n            hoverable\n            custom-detail-row\n            :opened-detailed=\"['Board Games']\"\n            :default-sort=\"['name', 'asc']\"\n            detail-key=\"name\"\n            @details-open=\"(row, index) => $buefy.toast.open(`Expanded ${row.name}`)\"\n            :show-detail-icon=\"showDetailIcon\">\n\n            <template slot-scope=\"props\">\n                <b-table-column\n                    field=\"name\"\n                    :visible=\"columnsVisible['name'].display\"\n                    :label=\"columnsVisible['name'].title\"\n                    width=\"300\"\n                    sortable\n                >\n                    <template v-if=\"showDetailIcon\">\n                        {{ props.row.name }}\n                    </template>\n                    <template v-else>\n                        <a @click=\"toggle(props.row)\">\n                            {{ props.row.name }}\n                        </a>\n                    </template>\n                </b-table-column>\n\n                <b-table-column\n                    field=\"sold\"\n                    :visible=\"columnsVisible['sold'].display\"\n                    :label=\"columnsVisible['sold'].title\"\n                    sortable\n                    centered\n                >\n                    {{ props.row.sold }}\n                </b-table-column>\n\n                <b-table-column\n                    field=\"available\"\n                    :visible=\"columnsVisible['available'].display\"\n                    :label=\"columnsVisible['available'].title\"\n                    sortable\n                    centered\n                >\n                    {{ props.row.available }}\n                </b-table-column>\n\n                <b-table-column\n                    :visible=\"columnsVisible['cleared'].display\"\n                    :label=\"columnsVisible['cleared'].title\"\n                    centered\n                >\n                    <span :class=\"\n                            [\n                                'tag',\n                                {'is-danger': props.row.sold / props.row.available <= 0.45},\n                                {'is-success': props.row.sold / props.row.available > 0.45}\n                            ]\">\n                        {{ Math.round((props.row.sold / props.row.available) * 100) }}%\n                    </span>\n                </b-table-column>\n            </template>\n\n            <template slot=\"detail\" slot-scope=\"props\">\n                <tr v-for=\"item in props.row.items\" :key=\"item.name\">\n                    <td v-if=\"showDetailIcon\"></td>\n                    <td v-show=\"columnsVisible['name'].display\" >&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</td>\n                    <td v-show=\"columnsVisible['sold'].display\" class=\"has-text-centered\">{{ item.sold }}</td>\n                    <td v-show=\"columnsVisible['available'].display\" class=\"has-text-centered\">{{ item.available }}</td>\n                    <td v-show=\"columnsVisible['cleared'].display\" class=\"has-text-centered\">\n                        <span :class=\"\n                            [\n                                'tag',\n                                {'is-danger': item.sold / item.available <= 0.45},\n                                {'is-success': item.sold / item.available > 0.45}\n                            ]\">\n                            {{ Math.round((item.sold / item.available) * 100) }}%\n                        </span>\n                    </td>\n                </tr>\n            </template>\n        </b-table>\n\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    {\n                        name: 'Board Games',\n                        sold: 131,\n                        available: 301,\n                        items: [\n                            {\n                                name: 'Monopoly',\n                                sold: 57,\n                                available: 100\n                            },\n                            {\n                                name: 'Scrabble',\n                                sold: 23,\n                                available: 84\n                            },\n                            {\n                                name: 'Chess',\n                                sold: 37,\n                                available: 61\n                            },\n                            {\n                                name: 'Battleships',\n                                sold: 14,\n                                available: 56\n                            }\n                        ]\n                    },\n                    {\n                        name: 'Jigsaws & Puzzles',\n                        sold: 88,\n                        available: 167,\n                        items: [\n                            {\n                                name: 'World Map',\n                                sold: 31,\n                                available: 38\n                            },\n                            {\n                                name: 'London',\n                                sold: 23,\n                                available: 29\n                            },\n                            {\n                                name: 'Sharks',\n                                sold: 20,\n                                available: 44\n                            },\n                            {\n                                name: 'Disney',\n                                sold: 14,\n                                available: 56\n                            }\n                        ]\n                    },\n                    {\n                        name: 'Books',\n                        sold: 434,\n                        available: 721,\n                        items: [\n                            {\n                                name: 'Hamlet',\n                                sold: 101,\n                                available: 187\n                            },\n                            {\n                                name: 'The Lord Of The Rings',\n                                sold: 85,\n                                available: 156\n                            },\n                            {\n                                name: 'To Kill a Mockingbird',\n                                sold: 78,\n                                available: 131\n                            },\n                            {\n                                name: 'Catch-22',\n                                sold: 73,\n                                available: 98\n                            },\n                            {\n                                name: 'Frankenstein',\n                                sold: 51,\n                                available: 81\n                            },\n                            {\n                                name: 'Alice\\'s Adventures In Wonderland',\n                                sold: 46,\n                                available: 68\n                            }\n                        ]\n                    }\n                ],\n                columnsVisible: {\n                    name: { title: 'Name', display: true },\n                    sold: { title: 'Stock Sold', display: true },\n                    available: { title: 'Stock Available', display: true },\n                    cleared: { title: 'Stock Cleared', display: true },\n                },\n                showDetailIcon: true\n            }\n        },\n        methods: {\n            toggle(row) {\n                this.$refs.table.toggleDetails(row)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1520:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-table\n        :data=\"data\"\n        :columns=\"columns\"\n        :row-class=\"(row, index) => row.id === 1 && 'is-info'\">\n    </b-table>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                    { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                    { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                    { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                    { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n                ],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '40',\n                        numeric: true\n                    },\n                    {\n                        field: 'first_name',\n                        label: 'First Name',\n                    },\n                    {\n                        field: 'last_name',\n                        label: 'Last Name',\n                    },\n                    {\n                        field: 'date',\n                        label: 'Date',\n                        centered: true\n                    },\n                    {\n                        field: 'gender',\n                        label: 'Gender',\n                    }\n                ]\n            }\n        }\n    }\n</script>\n\n<style>\n    tr.is-info {\n        background: #167df0;\n        color: #fff;\n    }\n</style>\n"

/***/ }),

/***/ 1521:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-table :data=\"data\">\n        <template slot-scope=\"props\">\n            <b-table-column field=\"id\" label=\"ID\" width=\"40\" numeric>\n                <template slot=\"header\" slot-scope=\"{ column }\">\n                    <b-tooltip :label=\"column.label\" dashed>\n                        {{ column.label }}\n                    </b-tooltip>\n                </template> \n                {{ props.row.id }}\n            </b-table-column>\n\n            <b-table-column field=\"user.first_name\" label=\"First Name\">\n                <template slot=\"header\" slot-scope=\"{ column }\">\n                    <b-tooltip :label=\"column.label\" dashed>\n                        {{ column.label }}\n                    </b-tooltip>\n                </template>\n                {{ props.row.first_name }}\n            </b-table-column>\n\n            <b-table-column field=\"user.last_name\" label=\"Last Name\">\n                <template slot=\"header\" slot-scope=\"{ column }\">\n                    <b-tooltip :label=\"column.label\" dashed>\n                        {{ column.label }}\n                    </b-tooltip>\n                </template>\n                {{ props.row.last_name }}\n            </b-table-column>\n\n            <b-table-column field=\"date\" label=\"Date\" centered>\n                <span class=\"tag is-success\">\n                    {{ new Date(props.row.date).toLocaleDateString() }}\n                </span>\n            </b-table-column>\n\n            <b-table-column label=\"Gender\">\n                <span>\n                    <b-icon pack=\"fas\"\n                        :icon=\"props.row.gender === 'Male' ? 'mars' : 'venus'\">\n                    </b-icon>\n                    {{ props.row.gender }}\n                </span>\n            </b-table-column>\n        </template>\n    </b-table>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                    { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                    { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                    { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                    { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1522:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-table\n            :data=\"data\"\n            :columns=\"columns\">\n        </b-table>\n    </section>\n</template>\n\n <script>\n    export default {\n        data() {\n            return {\n                data: [\n                    { 'id': 1, 'contributor': 'Jesse Simmons', 'posts': 2, 'comments': 5 },\n                    { 'id': 2, 'contributor': 'John Jacobs', 'posts': 11, 'comments': 42 },\n                    { 'id': 3, 'contributor': 'Tina Gilbert', 'posts': 0, 'comments': 7 },\n                    { 'id': 4, 'contributor': 'Clarence Flores', 'posts': 4, 'comments': 4 },\n                    { 'id': 5, 'contributor': 'Anne Lee', 'posts': 1, 'comments': 2 }\n                ],\n                columns: [\n                    {\n                        field: 'id',\n                        label: 'ID',\n                        width: '100',\n                        numeric: true,\n                        subheading: 'Total:'\n                    },\n                    {\n                        field: 'contributor',\n                        label: 'Contributor',\n                    },\n                    {\n                        field: 'posts',\n                        label: 'Posts',\n                        subheading: 18\n                    },\n                    {\n                        field: 'comments',\n                        label: 'Comments',\n                        subheading: 60\n                    }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1523:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <div v-for=\"(column, index) in columnsTemplate\" \n                :key=\"index\"\n                class=\"control\">\n                <b-checkbox v-model=\"column.visible\">\n                    {{ column.title }}\n                </b-checkbox>\n            </div>\n        </b-field>\n\n        <b-table :data=\"tableDataSimple\">\n            <template slot-scope=\"props\">\n                <b-table-column v-for=\"(column, index) in columnsTemplate\"\n                    :key=\"index\"\n                    :label=\"column.title\"\n                    :visible=\"column.visible\">\n                    {{ props.row[column.field] }}\n                </b-table-column>\n            </template>\n        </b-table>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            const tableDataSimple = [\n                { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n            ]\n\n            return {\n                tableDataSimple,\n                columnsTemplate: [\n                    { title: 'ID', field: 'id', visible: true },\n                    { title: 'First Name', field: 'first_name', visible: true },\n                    { title: 'Last Name', field: 'last_name', visible: true },\n                    { title: 'Date', field: 'date', visible: true },\n                    { title: 'Gender', field: 'gender', visible: true }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1524:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field grouped group-multiline>\n            <div class=\"control\">\n                <b-switch v-model=\"isCustom\">Custom</b-switch>\n            </div>\n        </b-field>\n        <b-table :data=\"tableDataSimple\">\n\n            <template slot-scope=\"props\">\n                <b-table-column label=\"ID\" width=\"40\" numeric>\n                    {{ props.row.id }}\n                </b-table-column>\n\n                <b-table-column label=\"First Name\">\n                    {{ props.row.first_name }}\n                </b-table-column>\n\n                <b-table-column label=\"Last Name\">\n                    {{ props.row.last_name }}\n                </b-table-column>\n\n                <b-table-column label=\"Date\" centered>\n                    {{ new Date(props.row.date).toLocaleDateString() }}\n                </b-table-column>\n\n                <b-table-column label=\"Gender\">\n                    {{ props.row.gender }}\n                </b-table-column>\n            </template>\n\n            <template slot=\"footer\" v-if=\"!isCustom\">\n                <div class=\"has-text-right\">\n                    Footer\n                </div>\n            </template>\n            <template slot=\"footer\" v-else>\n                <th class=\"is-hidden-mobile\" style=\"width:40px\">\n                    <div class=\"th-wrap is-numeric\"> ID </div>\n                </th>\n                <th class=\"is-hidden-mobile\">\n                    <div class=\"th-wrap\"> First Name </div>\n                </th>\n                <th class=\"is-hidden-mobile\">\n                    <div class=\"th-wrap\"> Last Name </div>\n                </th>\n                <th class=\"is-hidden-mobile\">\n                    <div class=\"th-wrap is-centered\"> Date </div>\n                </th>\n                <th class=\"is-hidden-mobile\">\n                    <div class=\"th-wrap\"> Gender </div>\n                </th>\n            </template>\n\n        </b-table>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            const tableDataSimple = [\n                { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' },\n                { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' },\n                { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' },\n                { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' },\n                { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }\n            ]\n\n            return {\n                tableDataSimple,\n                isCustom: false\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1525:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-table\n            :data=\"data\"\n            :loading=\"loading\"\n\n            paginated\n            backend-pagination\n            :total=\"total\"\n            :per-page=\"perPage\"\n            @page-change=\"onPageChange\"\n            aria-next-label=\"Next page\"\n            aria-previous-label=\"Previous page\"\n            aria-page-label=\"Page\"\n            aria-current-label=\"Current page\"\n\n            backend-sorting\n            :default-sort-direction=\"defaultSortOrder\"\n            :default-sort=\"[sortField, sortOrder]\"\n            @sort=\"onSort\">\n\n            <template slot-scope=\"props\">\n                <b-table-column field=\"original_title\" label=\"Title\" sortable>\n                    {{ props.row.original_title }}\n                </b-table-column>\n\n                <b-table-column field=\"vote_average\" label=\"Vote Average\" numeric sortable>\n                    <span class=\"tag\" :class=\"type(props.row.vote_average)\">\n                        {{ props.row.vote_average }}\n                    </span>\n                </b-table-column>\n\n                <b-table-column field=\"vote_count\" label=\"Vote Count\" numeric sortable>\n                     {{ props.row.vote_count }}\n                </b-table-column>\n\n                <b-table-column field=\"release_date\" label=\"Release Date\" sortable centered>\n                    {{ props.row.release_date ? new Date(props.row.release_date).toLocaleDateString() : '' }}\n                </b-table-column>\n\n                <b-table-column label=\"Overview\" width=\"500\">\n                    {{ props.row.overview | truncate(80) }}\n                </b-table-column>\n            </template>\n        </b-table>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [],\n                total: 0,\n                loading: false,\n                sortField: 'vote_count',\n                sortOrder: 'desc',\n                defaultSortOrder: 'desc',\n                page: 1,\n                perPage: 20\n            }\n        },\n        methods: {\n            /*\n        * Load async data\n        */\n            loadAsyncData() {\n                const params = [\n                    'api_key=bb6f51bef07465653c3e553d6ab161a8',\n                    'language=en-US',\n                    'include_adult=false',\n                    'include_video=false',\n                    `sort_by=${this.sortField}.${this.sortOrder}`,\n                    `page=${this.page}`\n                ].join('&')\n\n                this.loading = true\n                this.$http.get(`https://api.themoviedb.org/3/discover/movie?${params}`)\n                    .then(({ data }) => {\n                        // api.themoviedb.org manage max 1000 pages\n                        this.data = []\n                        let currentTotal = data.total_results\n                        if (data.total_results / this.perPage > 1000) {\n                            currentTotal = this.perPage * 1000\n                        }\n                        this.total = currentTotal\n                        data.results.forEach((item) => {\n                            item.release_date = item.release_date.replace(/-/g, '/')\n                            this.data.push(item)\n                        })\n                        this.loading = false\n                    })\n                    .catch((error) => {\n                        this.data = []\n                        this.total = 0\n                        this.loading = false\n                        throw error\n                    })\n            },\n            /*\n        * Handle page-change event\n        */\n            onPageChange(page) {\n                this.page = page\n                this.loadAsyncData()\n            },\n            /*\n        * Handle sort event\n        */\n            onSort(field, order) {\n                this.sortField = field\n                this.sortOrder = order\n                this.loadAsyncData()\n            },\n            /*\n        * Type style in relation to the value\n        */\n            type(value) {\n                const number = parseFloat(value)\n                if (number < 6) {\n                    return 'is-danger'\n                } else if (number >= 6 && number < 8) {\n                    return 'is-warning'\n                } else if (number >= 8) {\n                    return 'is-success'\n                }\n            }\n        },\n        filters: {\n            /**\n        * Filter to truncate string, accepts a length parameter\n        */\n            truncate(value, length) {\n                return value.length > length\n                    ? value.substr(0, length) + '...'\n                    : value\n            }\n        },\n        mounted() {\n            this.loadAsyncData()\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

module.exports = "<template>\n  <div>\n    <b-table\n      :data=\"data\"\n      :columns=\"columns\"\n      draggable\n      @dragstart=\"dragstart\"\n      @drop=\"drop\"\n      @dragover=\"dragover\"\n      @dragleave=\"dragleave\">\n    </b-table>\n  </div> \n</template>\n\n<script>\n  export default {\n      data() {\n          return {\n              data: [\n                  { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' },\n                  { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' },\n                  { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' },\n                  { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' },\n                  { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }\n              ],\n              columns: [\n                  {\n                      field: 'id',\n                      label: 'ID',\n                      width: '40',\n                      numeric: true\n                  },\n                  {\n                      field: 'first_name',\n                      label: 'First Name',\n                  },\n                  {\n                      field: 'last_name',\n                      label: 'Last Name',\n                  },\n                  {\n                      field: 'date',\n                      label: 'Date',\n                      centered: true\n                  },\n                  {\n                      field: 'gender',\n                      label: 'Gender',\n                  }\n              ],\n              draggingRow: null,\n              draggingRowIndex: null\n          }\n      },\n      methods: {\n        dragstart (payload) {\n          this.draggingRow = payload.row\n          this.draggingRowIndex = payload.index\n          payload.event.dataTransfer.effectAllowed = 'copy'\n        },\n        dragover(payload) {\n          payload.event.dataTransfer.dropEffect = 'copy'\n          payload.event.target.closest('tr').classList.add('is-selected')\n          payload.event.preventDefault()\n        },\n        dragleave(payload) {\n          payload.event.target.closest('tr').classList.remove('is-selected')\n          payload.event.preventDefault()\n        },\n        drop(payload) {\n          payload.event.target.closest('tr').classList.remove('is-selected')\n          const droppedOnRowIndex = payload.index\n          this.$buefy.toast.open(`Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`)\n        }\n      }\n  }\n</script>\n"

/***/ }),

/***/ 1527:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("To show a data table is very simple, you just need a "), _c('code', [_vm._v("data")]), _vm._v(" and a "), _c('code', [_vm._v("columns")]), _vm._v(" prop.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSandbox,
      "code": _vm.ExSandboxCode,
      "title": "Sandbox with custom template"
    }
  }, [_c('p', [_vm._v("To show a custom row template, you "), _c('b', [_vm._v("should not use the "), _c('code', [_vm._v("columns")]), _vm._v(" prop")]), _vm._v(", but add it within the scoped slot as a component.")]), _vm._v(" "), _c('p', [_vm._v("Also you can add an "), _c('code', [_vm._v("empty")]), _vm._v(" named slot to show when there's no data.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSelection,
      "code": _vm.ExSelectionCode,
      "title": "Selection"
    }
  }, [_c('p', [_vm._v("\n                You can show a "), _c('strong', [_vm._v("single selected")]), _vm._v(" row by passing the corresponding object to the "), _c('code', [_vm._v("selected")]), _vm._v(" prop.\n                Additionally, adding the "), _c('code', [_vm._v(".sync")]), _vm._v(" modifier will make it two-way binding — selected object will mutate if user clicks on row.\n            ")]), _vm._v(" "), _c('p', [_vm._v("Use "), _c('code', [_vm._v("focusable")]), _vm._v(" prop make table to be focused and navigable with a keyboard using "), _c('strong', [_vm._v("arrow keys")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCheckable,
      "code": _vm.ExCheckableCode,
      "title": "Checkable"
    }
  }, [_c('p', [_vm._v("You can add checkboxes to rows by using the "), _c('code', [_vm._v("checkable")]), _vm._v(" prop.")]), _vm._v(" "), _c('p', [_vm._v("\n                To show which rows are "), _c('strong', [_vm._v("checked")]), _vm._v(", you have to pass the corresponding object array to the "), _c('code', [_vm._v("checked-rows")]), _vm._v(" prop.\n                Adding the "), _c('code', [_vm._v(".sync")]), _vm._v(" modifier will make it two-way binding — checked object array will mutate if user clicks on checkboxes.\n            ")]), _vm._v(" "), _c('p', [_vm._v("A slot called "), _c('code', [_vm._v("bottom-left")]), _vm._v(" is available whenever the table is checkable or paginated, you can add anything in there.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSearchable,
      "code": _vm.ExSearchableCode,
      "title": "Searchable"
    }
  }, [_c('p', [_vm._v("You can add search filtering to rows by using the "), _c('code', [_vm._v("searchable")]), _vm._v(" prop.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                This feature is not available on mobile when "), _c('code', [_vm._v("mobile-card")]), _vm._v(".\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPaginationSort,
      "code": _vm.ExPaginationSortCode,
      "title": "Pagination and sorting"
    }
  }, [_c('p', [_vm._v("To make a column sortable, add the "), _c('code', [_vm._v("sortable")]), _vm._v(" prop on it and specify a "), _c('code', [_vm._v("field")]), _vm._v(" name.")]), _vm._v(" "), _c('p', [_vm._v("You can also use the "), _c('code', [_vm._v("default-sort")]), _vm._v(" prop to determine the default sort column and order. The column must be "), _c('code', [_vm._v("sortable")]), _vm._v(" to work.")]), _vm._v(" "), _c('p', [_vm._v("The "), _c('code', [_vm._v("default-sort-direction")]), _vm._v(" prop can be set to determine the default sort column direction on the first click.")]), _vm._v(" "), _c('p', [_vm._v("A slot called "), _c('code', [_vm._v("bottom-left")]), _vm._v(" is available whenever the table is checkable or paginated, you can add anything in there.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExDetailedRow,
      "code": _vm.ExDetailedRowCode,
      "title": "Detailed rows"
    }
  }, [_c('p', [_vm._v("You can have detailed rows by adding a "), _c('code', [_vm._v("detail")]), _vm._v(" named scoped slot and the "), _c('code', [_vm._v("detailed")]), _vm._v(" prop.")]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.2")])]), _vm._v(" "), _c('p', [_vm._v(" You can also toggle row detail programmatically using "), _c('code', [_vm._v("toggleDetails")]), _vm._v(" method and "), _c('code', [_vm._v(":show-detail-icon=\"false\"")]), _vm._v(" if you want to hide chevron icon.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomDetailedRow,
      "code": _vm.ExCustomDetailedRowCode,
      "title": "Custom Detailed rows"
    }
  }, [_c('p', [_vm._v("You can add anything you like into the "), _c('code', [_vm._v("detail")]), _vm._v(" named scoped by providing the "), _c('code', [_vm._v("customDetailRow")]), _vm._v(" prop to the table.")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                Be cautious when using a custom detailed row and toggling the display of columns,\n                as you will have to manage either the content within (with "), _c('code', [_vm._v("colspan")]), _vm._v(") or the columns themselves dependent on the content displayed.\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExRowStatus,
      "code": _vm.ExRowStatusCode,
      "title": "Row status"
    }
  }, [_c('p', [_vm._v("Use the "), _c('code', [_vm._v("row-class")]), _vm._v(" prop to return a class name. It's a function that receives "), _c('code', [_vm._v("row")]), _vm._v(" and "), _c('code', [_vm._v("index")]), _vm._v(" parameters.")]), _vm._v(" "), _c('p', [_vm._v("Note that "), _c('strong', [_vm._v("you have to style the class yourself")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomHeaders,
      "code": _vm.ExCustomHeadersCode,
      "title": "Custom headers"
    }
  }, [_c('p', [_vm._v("\n                By adding a scoped slot named "), _c('code', [_vm._v("header")]), _vm._v(" in table component you can customize the headers.\n                Use the "), _c('code', [_vm._v("meta")]), _vm._v(" prop on column to pass anything you may need.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Previous scoped slot named "), _c('code', [_vm._v("header")]), _vm._v(" in table will be deprecated.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSubheadings,
      "code": _vm.ExSubheadingsCode,
      "title": "Subheadings"
    }
  }, [_c('p', [_vm._v("\n                Use the "), _c('code', [_vm._v("subheading")]), _vm._v(" prop on columns to add subheadings. This is particularly useful to display a summary when dealing with long tables.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                By adding a scoped slot named "), _c('code', [_vm._v("subheading")]), _vm._v(" in table component you can customize the subheadings.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExToggleColumns,
      "code": _vm.ExToggleColumnsCode,
      "title": "Toggle columns"
    }
  }, [_c('b-message', {
    attrs: {
      "type": "is-danger"
    }
  }, [_vm._v("\n                Always use the "), _c('code', [_vm._v("visible")]), _vm._v(" prop to hide/show columns, and "), _c('strong', [_vm._v("NOT")]), _vm._v(" "), _c('code', [_vm._v("v-if")]), _vm._v(" or "), _c('code', [_vm._v("v-show")]), _vm._v(".\n            ")])], 1), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFooter,
      "code": _vm.ExFooterCode,
      "title": "Footer"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAsyncData,
      "code": _vm.ExAsyncDataCode,
      "title": "Async data"
    }
  }, [_c('p', [_vm._v("\n                Use "), _c('code', [_vm._v("backend-sorting")]), _vm._v(" and "), _c('code', [_vm._v("backend-pagination")]), _vm._v(" props to let those tasks to the backend,\n                then manage it with "), _c('code', [_vm._v("page-change")]), _vm._v(" and "), _c('code', [_vm._v("sort")]), _vm._v(" events.\n            ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")]), _vm._v(".")])])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExDraggableRows,
      "code": _vm.ExDraggableRowsCode,
      "title": "Draggable rows"
    }
  }, [_c('p', [_vm._v("\n                Use "), _c('code', [_vm._v("draggable")]), _vm._v(" prop to allow rows to be draggable. Manage dragging using "), _c('code', [_vm._v("dragstart")]), _vm._v(",\n                "), _c('code', [_vm._v("dragover")]), _vm._v(" and "), _c('code', [_vm._v("drop")]), _vm._v(" events\n            ")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Table',
    props: [{
        name: '<code>data</code>',
        description: 'Table data',
        type: 'Array<Object>',
        values: '—',
        default: '—'
    }, {
        name: '<code>columns</code>',
        description: 'Table columns, you can also add <code>renderHtml: true</code> on each column object',
        type: 'Array<Object> (same as TableColumns props)',
        values: '—',
        default: '—'
    }, {
        name: '<code>default-sort</code>',
        description: 'Sets the default sort column and order \u2014 e.g. <code>[\'first_name\', \'desc\']</code>',
        type: 'String, Array',
        values: '—',
        default: 'order: <code>default-sort-direction</code> prop'
    }, {
        name: '<code>default-sort-direction</code>',
        description: 'Sets the default sort column direction on the first click',
        type: 'String',
        values: '<code>asc</code>, <code>desc</code>',
        default: '<code>asc</code>'
    }, {
        name: '<code>sort-icon</code>',
        description: 'Sets the header sorting icon',
        type: 'String',
        values: '-',
        default: '<code>arrow-up</code>'
    }, {
        name: '<code>sort-icon-size</code>',
        description: 'Sets the size of the sorting icon',
        type: 'String',
        values: '<code>is-small</code>, <code></code>, <code>is-medium</code>, <code>is-large</code>',
        default: '<code>is-small</code>'
    }, {
        name: '<code>bordered</code>',
        description: 'Border to all cells',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>striped</code>',
        description: 'Whether table is striped',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>narrowed</code>',
        description: 'Makes the cells narrower',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>selected</code>',
        description: 'Set which row is selected, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Object',
        values: '—',
        default: '—'
    }, {
        name: '<code>focusable</code>',
        description: 'Table can be focused and user can navigate with keyboard arrows (require <code>selected.sync</code>) and rows are highlighted when hovering',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>hoverable</code>',
        description: 'Rows are highlighted when hovering',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>checkable</code>',
        description: 'Rows can be checked (multiple), checked rows will have a <code>.is-checked</code> class if you want to style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>checkbox-position</code>',
        description: 'Position of the checkbox (if <code>checkable</code> is true)',
        type: 'String',
        values: '<code>left</code> or <code>right</code>',
        default: '<code>left</code>'
    }, {
        name: '<code>checked-rows</code>',
        description: 'Set which rows are checked, use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Array<Object>',
        values: '—',
        default: '—'
    }, {
        name: '<code>header-checkable</code>',
        description: 'Show check/uncheck all checkbox in table header when <code>checkable</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>mobile-cards</code>',
        description: 'Rows appears as cards on mobile (collapse rows)',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>backend-sorting</code>',
        description: 'Columns won\'t be sorted with Javascript, use with <code>sort</code> event to sort in your backend',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>backend-pagination</code>',
        description: 'Rows won\'t be paginated with Javascript, use with <code>page-change</code> event to paginate in your backend',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>total</code>',
        description: 'Total number of table data if <code>backend-pagination</code> is enabled',
        type: 'Number',
        values: '—',
        default: '<code>0</code>'
    }, {
        name: '<code>current-page</code>',
        description: 'Current page of table data (if <code>paginated</code>), use the <code>.sync</code> modifier to make it two-way binding',
        type: 'Number',
        values: '—',
        default: '<code>1</code>'
    }, {
        name: '<code>loading</code>',
        description: 'Loading state',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>paginated</code>',
        description: 'Adds pagination to the table',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>pagination-simple</code>',
        description: 'Simple pagination (if <code>paginated</code>)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>pagination-size</code>',
        description: 'Pagination size (if <code>paginated</code>)',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>pagination-position</code>',
        description: 'Pagination position (if <code>paginated</code>)',
        type: 'String',
        values: '<code>bottom</code>, <code>top</code>, <code>both</code>',
        default: '<code>bottom</code>'
    }, {
        name: '<code>per-page</code>',
        description: 'How many rows per page (if <code>paginated</code>)',
        type: 'Number',
        values: '—',
        default: '<code>20</code>'
    }, {
        name: '<code>row-class</code>',
        description: 'Add a class to row (<code>&lt;tr&gt;</code> element) based on the return',
        type: 'Function (row: Object, index: Number)',
        values: '—',
        default: '—'
    }, {
        name: '<code>detailed</code>',
        description: 'Allow row details (check scoped slots documentation)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>custom-detail-row</code>',
        description: 'Allow a custom detail row',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>show-detail-icon</code>',
        description: 'Allow chevron icon and column to be visible',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>opened-detailed</code>',
        description: 'Allow pre-defined opened details. Ideal to open details via vue-router. (A unique key is required; check detail-key prop)',
        type: 'Array',
        values: '—',
        default: '<code>[]</code>'
    }, {
        name: '<code>has-detailed-visible</code>',
        description: 'Controls the visibility of the trigger that toggles the detailed rows.',
        type: 'Function (row: Object)',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>detail-key</code>',
        description: 'Use a unique key of your data Object when use detailed or opened detailed. (id recommended)',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>custom-is-checked</code>',
        description: 'Custom method to verify if row is checked, works when is <code>checkable</code>. Useful for backend pagination',
        type: 'Function (a: Object, b: Object)',
        values: '—',
        default: '—'
    }, {
        name: '<code>is-row-checkable</code>',
        description: 'Custom method to verify if a row is disabled, works when is <code>checkable</code>. ',
        type: 'Function (row: Object)',
        values: '—',
        default: 'true'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>mobile-sort-placeholder</code>',
        description: 'Text when nothing is selected',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>custom-row-key</code>',
        description: 'Use a unique key of your <code>data</code> Object for each row. Useful if your <code>data</code> prop has dynamic indices. (id recommended)',
        type: 'String',
        values: '-',
        default: '-'
    }, {
        name: '<code>draggable</code>',
        description: 'Allows rows to be draggable',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'

    }, {
        name: '<code>aria-next-label</code>',
        description: 'Accessibility label for the next page link (if <code>paginated</code>)',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-previous-label</code>',
        description: 'Accessibility label for the previous page link (if <code>paginated</code>)',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-page-label</code>',
        description: 'Accessibility label for the page link. If passed, this text will be prepended to the number of the page (if <code>paginated</code>)',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>aria-current-label</code>',
        description: 'Accessibility label for the current page link. If passed, this text will be prepended to the current page (if <code>paginated</code>)',
        type: 'String',
        values: '—',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: '<strong>Required</strong>, table body and header',
        props: '<code>row: Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>header</code>',
        description: 'Table custom header',
        props: '<code>column: Vue Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>subheading</code>',
        description: 'Table subheading',
        props: '<code>column: Vue Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>detail</code>',
        description: 'Row detail (collapsible)',
        props: '<code>row: Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>empty</code>',
        description: 'Replaces table body when <code>data</code> array prop is empty',
        props: '—'
    }, {
        name: '<code>footer</code>',
        description: 'Table custom footer',
        props: '—'
    }, {
        name: '<code>bottom-left</code>',
        description: 'Custom bottom-left (opposite side of bottom pagination)',
        props: '—'
    }, {
        name: '<code>top-left</code>',
        description: 'Custom top-left (opposite side of top pagination)',
        props: '—'
    }],
    events: [{
        name: '<code>click</code>',
        description: 'Triggers when a row is clicked',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>dblclick</code>',
        description: 'Triggers when a row is double clicked',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>sort</code>',
        description: 'Triggers when a sortable column is clicked',
        parameters: '<code>field: String</code>, <code>order: String</code>'
    }, {
        name: '<code>select</code>',
        description: 'Triggers when a row is selected',
        parameters: '<code>row: Object</code>, <code>oldRow: Object</code>'
    }, {
        name: '<code>check</code>',
        description: 'Triggers when the checkbox in a row is clicked and/or when the header checkbox is clicked',
        parameters: '<code>checkedList: Array</code>, <code>row: Object</code>'
    }, {
        name: '<code>check-all</code>',
        description: 'Triggers when the header checkbox is clicked',
        parameters: '<code>checkedList: Array</code>'
    }, {
        name: '<code>page-change</code>',
        description: 'Triggers when pagination page is changed',
        parameters: '<code>page: Number</code>'
    }, {
        name: '<code>details-open</code>',
        description: 'Triggers when details is opened',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>details-close</code>',
        description: 'Triggers when details is closed',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>contextmenu</code>',
        description: 'Triggers when right-click on a row',
        parameters: '<code>row: Object</code>, <code>contextMenuNativeEvent: Event</code>'
    }, {
        name: '<code>dragstart</code>',
        description: 'Triggers when starting to drag a row',
        parameters: '<code> row: Object </code>, <code> dragEvent: Event </code>, <code> index: Number </code>'
    }, {
        name: '<code>dragend</code>',
        description: 'Triggers when ending to drag a row',
        parameters: '<code> row: Object </code>, <code> dragEvent: Event </code>, <code> index: Number </code>'
    }, {
        name: '<code>drop</code>',
        description: 'Triggers when dropping on a row',
        parameters: '<code> row: Object </code>, <code> drop: Event </code>, <code> index: Number </code>'
    }, {
        name: '<code>dragover</code>',
        description: 'Triggers when dragging over a row',
        parameters: '<code> row: Object </code>, <code> dragover: Event </code>, <code> index: Number </code>'
    }, {
        name: '<code>mouseenter</code>',
        description: 'Triggers when mouse enters a row',
        parameters: '<code> row: Object </code>'
    }, {
        name: '<code>mouseleave</code>',
        description: 'Triggers when mouse leaves a row',
        parameters: '<code> row: Object </code>'
    }],
    methods: [{
        name: '<code>initSort</code>',
        description: 'Sort using <code>default-sort</code> prop parameters'
    }, {
        name: '<code>focus</code>',
        description: 'Focus table element if is <code>focusable</code>'
    }, {
        name: '<code>toggleDetails</code>',
        description: 'Toggle row detail if table is <code>detailed</code>',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>openDetailRow</code>',
        description: 'Open row detail if table is <code>detailed</code>',
        parameters: '<code>row: Object</code>'
    }, {
        name: '<code>closeDetailRow</code>',
        description: 'Close row detail if table is <code>detailed</code>',
        parameters: '<code>row: Object</code>'
    }]
}, {
    title: 'Column',
    props: [{
        name: '<code>label</code>',
        description: 'Column header text, also used to identify column if <code>custom-key</code> prop is missing',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>custom-key</code>',
        description: 'Unique identifier, use when <code>label</code> is missing or there are duplicate <code>label</code> names',
        type: 'String, Number',
        values: '—',
        default: '<code>this.label</code>'
    }, {
        name: '<code>field</code>',
        description: 'Property of the object the column is attributed, used for sorting',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>meta</code>',
        description: 'Meta prop to add anything, useful when creating custom headers',
        type: 'Any',
        values: '—',
        default: '—'
    }, {
        name: '<code>width</code>',
        description: 'Column fixed width in pixels',
        type: 'Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>numeric</code>',
        description: 'Align the cell content to the right, sort icon on left',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>centered</code>',
        description: 'Align the cell content to the center',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>sortable</code>',
        description: 'Whether the column can be sorted',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>visible</code>',
        description: 'Whether the column is visible',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>custom-sort</code>',
        description: 'Custom sort method, works when is <code>sortable</code>',
        type: 'Function (a: Object, b: Object, isAsc: Boolean)',
        values: '—',
        default: '—'
    }, {
        name: '<code>searchable</code>',
        description: 'Add a input below the header to filter data',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>subheading</code>',
        description: 'Column subheading text',
        type: 'String, Number',
        values: '—',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: '<strong>Required</strong>, table column body',
        props: '-'
    }, {
        name: '<code>header</code>',
        description: 'Table column custom header',
        props: '<code>column: Vue Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>subheading</code>',
        description: 'Table column custom subheading',
        props: '<code>column: Vue Object</code>, <code>index: Number</code>'
    }]
}]);

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1198),
  /* template */
  __webpack_require__(1199),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1200),
  /* template */
  __webpack_require__(1201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1202),
  /* template */
  __webpack_require__(1203),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1204),
  /* template */
  __webpack_require__(1205),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1206),
  /* template */
  __webpack_require__(1207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1208),
  /* template */
  __webpack_require__(1209),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1210),
  /* template */
  __webpack_require__(1211),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1212),
  /* template */
  __webpack_require__(1213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1216),
  /* template */
  __webpack_require__(1217),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1218),
  /* template */
  __webpack_require__(1219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1220),
  /* template */
  __webpack_require__(1221),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1222),
  /* template */
  __webpack_require__(1223),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1224),
  /* template */
  __webpack_require__(1225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1226),
  /* template */
  __webpack_require__(1227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1228),
  /* template */
  __webpack_require__(1229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1511),
  /* template */
  __webpack_require__(1527),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

module.exports = [{"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016/10/15 13:43:27","gender":"Male"},{"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016/12/15 06:00:53","gender":"Male"},{"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016/04/26 06:26:28","gender":"Female"},{"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016/04/10 10:28:46","gender":"Male"},{"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016/12/06 14:38:38","gender":"Female"},{"id":6,"user":{"first_name":"Sara","last_name":"Armstrong"},"date":"2016/09/23 18:50:04","gender":"Female"},{"id":7,"user":{"first_name":"Anthony","last_name":"Webb"},"date":"2016/08/30 23:49:38","gender":"Male"},{"id":8,"user":{"first_name":"Andrew","last_name":"Greene"},"date":"2016/11/20 14:57:47","gender":"Male"},{"id":9,"user":{"first_name":"Russell","last_name":"White"},"date":"2016/07/13 09:29:49","gender":"Male"},{"id":10,"user":{"first_name":"Lori","last_name":"Hunter"},"date":"2016/12/09 01:44:05","gender":"Female"},{"id":11,"user":{"first_name":"Ronald","last_name":"Wood"},"date":"2016/12/04 02:23:48","gender":"Male"},{"id":12,"user":{"first_name":"Michael","last_name":"Harper"},"date":"2016/07/27 13:28:15","gender":"Male"},{"id":13,"user":{"first_name":"George","last_name":"Dunn"},"date":"2017/03/07 12:26:52","gender":"Male"},{"id":14,"user":{"first_name":"Eric","last_name":"Rogers"},"date":"2016/06/07 05:41:52","gender":"Male"},{"id":15,"user":{"first_name":"Juan","last_name":"Meyer"},"date":"2017/02/01 04:56:34","gender":"Male"},{"id":16,"user":{"first_name":"Lori","last_name":"Shaw"},"date":"2017/01/26 11:50:04","gender":"Female"},{"id":17,"user":{"first_name":"Lori","last_name":"Cunningham"},"date":"2016/05/01 10:00:56","gender":"Female"},{"id":18,"user":{"first_name":"Charles","last_name":"Graham"},"date":"2016/05/31 06:43:30","gender":"Male"},{"id":19,"user":{"first_name":"Henry","last_name":"Morrison"},"date":"2016/09/27 16:15:44","gender":"Male"},{"id":20,"user":{"first_name":"Albert","last_name":"Mendoza"},"date":"2016/08/08 05:29:24","gender":"Male"},{"id":21,"user":{"first_name":"Ruby","last_name":"Snyder"},"date":"2017/04/01 12:04:39","gender":"Female"},{"id":22,"user":{"first_name":"Jesse","last_name":"Warren"},"date":"2016/08/20 01:36:38","gender":"Male"},{"id":23,"user":{"first_name":"Carlos","last_name":"Ferguson"},"date":"2016/05/31 10:40:29","gender":"Male"},{"id":24,"user":{"first_name":"Melissa","last_name":"Peters"},"date":"2016/07/23 00:41:54","gender":"Female"},{"id":25,"user":{"first_name":"Arthur","last_name":"Garza"},"date":"2017/03/11 14:11:37","gender":"Male"},{"id":26,"user":{"first_name":"Joe","last_name":"Berry"},"date":"2016/07/09 15:16:56","gender":"Male"},{"id":27,"user":{"first_name":"Joseph","last_name":"Bishop"},"date":"2016/10/04 19:44:54","gender":"Male"},{"id":28,"user":{"first_name":"Sarah","last_name":"Harper"},"date":"2016/09/23 05:09:11","gender":"Female"},{"id":29,"user":{"first_name":"Christopher","last_name":"Fuller"},"date":"2016/04/12 00:05:35","gender":"Male"},{"id":30,"user":{"first_name":"Alan","last_name":"Mendoza"},"date":"2016/04/22 10:48:02","gender":"Male"},{"id":31,"user":{"first_name":"James","last_name":"Davis"},"date":"2017/01/16 15:17:03","gender":"Male"},{"id":32,"user":{"first_name":"Scott","last_name":"Welch"},"date":"2016/10/04 23:31:51","gender":"Male"},{"id":33,"user":{"first_name":"Mildred","last_name":"Myers"},"date":"2016/11/23 13:46:18","gender":"Female"},{"id":34,"user":{"first_name":"Victor","last_name":"Martinez"},"date":"2016/04/06 17:05:07","gender":"Male"},{"id":35,"user":{"first_name":"Susan","last_name":"Medina"},"date":"2016/12/09 10:33:37","gender":"Female"},{"id":36,"user":{"first_name":"Judy","last_name":"Long"},"date":"2016/07/26 16:19:04","gender":"Female"},{"id":37,"user":{"first_name":"Joan","last_name":"Myers"},"date":"2016/09/22 04:55:54","gender":"Female"},{"id":38,"user":{"first_name":"Rachel","last_name":"Gonzales"},"date":"2016/07/15 13:56:38","gender":"Female"},{"id":39,"user":{"first_name":"Roger","last_name":"Hunt"},"date":"2016/08/14 10:43:11","gender":"Male"},{"id":40,"user":{"first_name":"Dorothy","last_name":"Howard"},"date":"2016/06/19 05:34:49","gender":"Female"},{"id":41,"user":{"first_name":"Eugene","last_name":"Lynch"},"date":"2016/12/24 08:19:24","gender":"Male"},{"id":42,"user":{"first_name":"Kathy","last_name":"Webb"},"date":"2017/04/01 21:09:05","gender":"Female"},{"id":43,"user":{"first_name":"Antonio","last_name":"White"},"date":"2017/02/10 06:51:20","gender":"Male"},{"id":44,"user":{"first_name":"Louis","last_name":"Spencer"},"date":"2016/10/08 02:20:22","gender":"Male"},{"id":45,"user":{"first_name":"Andrea","last_name":"Marshall"},"date":"2016/09/04 10:59:57","gender":"Female"},{"id":46,"user":{"first_name":"Eugene","last_name":"Sims"},"date":"2017/03/15 06:39:48","gender":"Male"},{"id":47,"user":{"first_name":"Mildred","last_name":"Gibson"},"date":"2016/04/18 06:43:54","gender":"Female"},{"id":48,"user":{"first_name":"Joan","last_name":"Arnold"},"date":"2016/12/16 04:52:23","gender":"Female"},{"id":49,"user":{"first_name":"Jesse","last_name":"Schmidt"},"date":"2016/06/11 02:44:33","gender":"Male"},{"id":50,"user":{"first_name":"David","last_name":"Frazier"},"date":"2017/02/15 21:46:30","gender":"Male"},{"id":51,"user":{"first_name":"Nicholas","last_name":"Howell"},"date":"2016/11/01 15:08:31","gender":"Male"},{"id":52,"user":{"first_name":"Douglas","last_name":"Chapman"},"date":"2017/02/08 03:33:24","gender":"Male"},{"id":53,"user":{"first_name":"Bruce","last_name":"Simmons"},"date":"2016/07/14 12:11:17","gender":"Male"},{"id":54,"user":{"first_name":"Antonio","last_name":"George"},"date":"2016/11/07 19:12:55","gender":"Male"},{"id":55,"user":{"first_name":"Chris","last_name":"Marshall"},"date":"2016/07/03 12:11:45","gender":"Male"},{"id":56,"user":{"first_name":"Ashley","last_name":"Hudson"},"date":"2016/10/14 21:08:05","gender":"Female"},{"id":57,"user":{"first_name":"Alan","last_name":"Edwards"},"date":"2017/03/22 21:10:25","gender":"Male"},{"id":58,"user":{"first_name":"George","last_name":"Clark"},"date":"2016/04/28 03:15:05","gender":"Male"},{"id":59,"user":{"first_name":"Frank","last_name":"Porter"},"date":"2016/09/08 00:48:14","gender":"Male"},{"id":60,"user":{"first_name":"Christopher","last_name":"Palmer"},"date":"2016/05/24 08:58:12","gender":"Male"}]

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.1915aead7357ae53eec5.js